import { render, staticRenderFns } from "./loginByUnion.vue?vue&type=template&id=71314078"
import script from "./loginByUnion.vue?vue&type=script&lang=js"
export * from "./loginByUnion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports